module.exports = __webpack_public_path__ + "src/assets/img/illustrations/suggestion-card-travel-time.09b9a230935978022ca33436b786cf9b.png";